import { memo, useState } from 'react';
import {
  Select as CustomSelect,
  Option as CustomOption,
  Label,
} from './SelectorStyled';
import MenuItem from '@material-ui/core/MenuItem';
import MuiSelect from '@material-ui/core/Select';
import { makeStyles } from '@material-ui/core/styles';
import { noop } from 'utils/global-utils';

const useStyles = makeStyles(() => ({
  select: {
    width: '100% !important',
  },
}));

const Selector = ({
  className,
  options,
  optionSelected,
  defaultOption,
  hasDefaultOption = true,
  handleChange,
  register = noop,
  name,
  testId,
  fullWidth,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const classes = useStyles();
  const isOpenToggle = () => setIsOpen(!isOpen);
  const isOpenToggleOnBlur = () => {
    if (isOpen) {
      setIsOpen(!isOpen);
    }
  };
  const arrowIcon = () => (
    <img src={'/assets/icons/arrow_selector.svg'} alt={''} />
  );

  const renderSelect = () => {
    let Select, Option;
    if (fullWidth) {
      Select = MuiSelect;
      Option = MenuItem;
    } else {
      Select = CustomSelect;
      Option = CustomOption;
    }
    return (
      <Select
        {...register(name)}
        onClick={isOpenToggle}
        onBlur={isOpenToggleOnBlur}
        onChange={handleChange}
        value={optionSelected}
        className={className || classes.select}
        data-testid={testId}
        IconComponent={arrowIcon}
      >
        {hasDefaultOption && (
          <Option value={defaultOption.value} disabled selected>
            {defaultOption.translation}
          </Option>
        )}
        {options.map((option, key) => (
          <Option key={key} value={option.value}>
            {option.translation}
          </Option>
        ))}
      </Select>
    );
  };

  return fullWidth ? (
    renderSelect()
  ) : (
    <Label isOpen={isOpen}>{renderSelect()}</Label>
  );
};

export default memo(
  Selector,
  (prevProps, nextProps) =>
    prevProps.optionSelected === nextProps.optionSelected,
);
